import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import type { PosLayout } from '@/api/types'
import { posLayoutsApi } from '@/api/endpoints/pos-layouts'

export function usePosLayout(restaurantId?: number | null) {
  return useQuery({
    queryKey: ['pos-layout', restaurantId],
    queryFn: () => posLayoutsApi.get(restaurantId as number),
    enabled: !!restaurantId,
  })
}

export function useSavePosLayout(restaurantId?: number | null) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (layout: PosLayout) =>
      posLayoutsApi.save(restaurantId as number, layout),
    onSuccess: () => {
      toast.success('Layout saved and published')
      queryClient.invalidateQueries({ queryKey: ['pos-layout', restaurantId] })
    },
    onError: () => {
      toast.error('Failed to save layout')
    },
  })
}
